import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetThreadedViewDataRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetThreadedViewDataResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getThreadedViewData = (request: GetThreadedViewDataRequest, options?: CashRequestOptions) =>
  post<GetThreadedViewDataRequest, GetThreadedViewDataResponse>('/2.0/cash/get-threaded-view-data', request, {
    ...options,
    rejectOnError: true,
  })
